import { render, staticRenderFns } from "./VersionUpdateDialog.vue?vue&type=template&id=6164d1fd"
import script from "./VersionUpdateDialog.vue?vue&type=script&lang=js"
export * from "./VersionUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports